"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_use_1 = require("react-use");
const mui_1 = require("tss-react/mui");
const react_redux_1 = require("react-redux");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const AccountBalanceRounded_1 = __importDefault(require("@mui/icons-material/AccountBalanceRounded"));
const auth_1 = require("companion-app-components/flux/auth");
const institutionLoginsSelectors = __importStar(require("data/institutionLogins/selectors"));
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const accounts_1 = require("companion-app-components/flux/accounts");
const utils_1 = require("companion-app-components/hooks/utils");
const institutionsSelectors = __importStar(require("companion-app-components/flux/institutions/institutionsSelectors"));
const QButton_1 = __importDefault(require("components/QButton"));
const AccountCard_1 = __importDefault(require("components/AccountCard"));
const RendersCount_1 = __importDefault(require("components/RendersCount"));
const actions_1 = require("data/institutionLogins/actions");
const actions_2 = require("data/AccountDiscovery/actions");
const under_construction_png_1 = __importDefault(require("assets/under-construction.png"));
const selectors_1 = require("data/datasetSharing/selectors");
const utils_2 = require("../../utils");
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const BankAccounts = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { classes } = useStyles();
    const accountsByInstitutionLoginId = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getAccountsByInstitutionLoginId(state)); // 2nd params props
    const institutionLogins = (0, react_redux_1.useSelector)((state) => institutionLoginsSelectors.getInstitutionLoginsByName(state)); // 2nd params props
    const institutions = (0, react_redux_1.useSelector)((state) => institutionsSelectors.getInstitutionsById(state));
    const isWebFirstDataset = (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getIsWebfirstDataset(state));
    const featureFlags = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state));
    const canAddAccount = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getIsFeatureAllowed)(state, selectors_1.AllFeatures.ADD_ACCOUNTS));
    const manageAccountsGroupManualByType = featureFlags.get('manageAccountsGroupManualByType');
    const accountEnabled = featureFlags.get('accountsManagement');
    const addFi = featureFlags.get('addFi');
    (0, react_use_1.useEffectOnce)(() => {
        (0, utils_1.fetchOnce)(accounts_1.accountsActions.getAccounts, accounts_1.accountsSelectors, true);
        (0, utils_1.fetchOnce)(actions_1.getInstitutionLogins, institutionLoginsSelectors, true);
    });
    const manualAccounts = React.useMemo(() => (0, utils_2.getManualAccounts)(accountsByInstitutionLoginId, institutionLogins, manageAccountsGroupManualByType), [accountsByInstitutionLoginId, institutionLogins, manageAccountsGroupManualByType]);
    const handleRequestCreate = (event) => {
        event.stopPropagation();
        dispatch((0, actions_2.doAccountDiscovery)({ initiator: 'settings accounts' }));
    };
    if (!accountEnabled) {
        return (<img className={classes.underConstruction} alt="page is under construction" src={under_construction_png_1.default}/>);
    }
    const renderCards = () => (<Grid_1.default container direction="column">
      {/* @ts-expect-error: Type 'number | undefined' is not assignable to type 'number'. */}
      {accountsByInstitutionLoginId.entrySeq().sort((institutionEntry1, institutionEntry2) => { var _a, _b; return (_a = institutionLogins.get(institutionEntry1[0])) === null || _a === void 0 ? void 0 : _a.name.localeCompare((_b = institutionLogins.get(institutionEntry2[0])) === null || _b === void 0 ? void 0 : _b.name); }).map(([institutionLoginId, institutionLoginAccounts], index) => {
            const institutionLogin = institutionLogins === null || institutionLogins === void 0 ? void 0 : institutionLogins.get(institutionLoginId);
            if (institutionLoginId === '0' || ((institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.institutionId) === '0' && (institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.name) === 'unknown')) {
                // Need to handle case where client (i.e. Windows) adds all manual accounts to an InstitutionLogin. We recognize
                // this by seeing if the institutionId is '0' and the name is not set. The reason we check for name is so that
                // manual grouped accounts can be supported by adding to an InstitutionLogin with a valid name.
                return null;
            }
            // let accounts = accountsByInstitutionLoginId ? accountsByInstitutionLoginId.get(institutionLogin.id) : null;
            let accounts = institutionLoginAccounts;
            if ((!accounts || accounts.size === 0)) {
                verify(false, `orphaned institution login '${institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.name}' has no linked accounts`);
                return null;
            }
            accounts = accounts === null || accounts === void 0 ? void 0 : accounts.sortBy((account) => account.name);
            return (<AccountCard_1.default id={`account-card-${index}`} accounts={accounts} branding={(0, utils_2.getInstitutionBranding)(institutions, institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.institutionId)} institutionLogin={institutionLogin} key={(institutionLogin === null || institutionLogin === void 0 ? void 0 : institutionLogin.id) || `institution-${index}`} isWebFirstDataset={isWebFirstDataset}/>);
        }).toList()}

      {manageAccountsGroupManualByType && (manualAccounts === null || manualAccounts === void 0 ? void 0 : manualAccounts.banking) && (<AccountCard_1.default id="account-card-manual-banking" accounts={manualAccounts.banking} key="manual-banking-accounts" title="Manual Banking and Cash Accounts" isWebFirstDataset={isWebFirstDataset}/>)}

      {manageAccountsGroupManualByType && (manualAccounts === null || manualAccounts === void 0 ? void 0 : manualAccounts.investments) && (<AccountCard_1.default id="account-card-manual-banking" accounts={manualAccounts.investments} key="manual-investments-accounts" title="Investment Accounts" isWebFirstDataset={isWebFirstDataset}/>)}

      {manageAccountsGroupManualByType && (manualAccounts === null || manualAccounts === void 0 ? void 0 : manualAccounts.assetsAndLiabilties) && (<AccountCard_1.default id="account-card-manual-banking" accounts={manualAccounts.assetsAndLiabilties} key="manual-assets-and-liabilties-accounts" title="Assets and Liabilities" isWebFirstDataset={isWebFirstDataset}/>)}

      {!manageAccountsGroupManualByType && manualAccounts && (<AccountCard_1.default id="account-card-manual" accounts={manualAccounts} key="manual-accounts" title="Manual Accounts" isWebFirstDataset={isWebFirstDataset}/>)}
    </Grid_1.default>);
    return institutions !== undefined && (<Grid_1.default container direction="column">
      <RendersCount_1.default id="accounts-tab"/>
      <Grid_1.default className={classes.headerContainer} container justifyContent="space-between" alignItems="flex-start">
        <Typography_1.default className={classes.sectionHeadline} variant="h5">
          <AccountBalanceRounded_1.default className={classes.headlineIcon}/>
          Accounts
        </Typography_1.default>
        {canAddAccount && addFi && isWebFirstDataset && (<QButton_1.default id="accounts-add-new-button" variant="contained" onClick={handleRequestCreate}>
            <Add_1.default className={classes.iconSpacing}/> ACCOUNT
          </QButton_1.default>)}
      </Grid_1.default>
      <Grid_1.default container direction="column">
        {renderCards()}
      </Grid_1.default>
    </Grid_1.default>);
};
exports.default = BankAccounts;
